// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderSummeryTableStyles } from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPages/OrderSummeryTableStyles";
import { mergeWithCss } from "@hardwoods/XDL/Utilities/mergeWithCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
    extendedStyles?: OrderSummaryStyle;
}

export interface OrderSummaryStyle {
    mainWrapper?: InjectableCss;
    container?: GridContainerProps;
    titleContainer?: GridContainerProps;
    orderSummeryTitleGridItem?: GridItemProps;
    orderSummeryTitle?: TypographyProps;
}

const orderSummaryStyle: OrderSummaryStyle = {
    mainWrapper: {
        ...orderSummeryTableStyles.mainWrapper,
    },
    titleContainer: {
        ...orderSummeryTableStyles.titleContainer,
    },
    orderSummeryTitleGridItem: {
        ...orderSummeryTableStyles.orderSummeryTitleGridItem,
    },
    orderSummeryTitle: {
        ...orderSummeryTableStyles.orderSummeryTitle,
    },
    container: {
        ...orderSummeryTableStyles.container,
    },
};

const OrderSummaryWrapper: FC<OwnProps> = ({ id, fields: { title }, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(orderSummaryStyle, extendedStyles));

    return (
        <StyledWrapper {...styles.mainWrapper}>
            <GridContainer {...styles.titleContainer}>
                <GridItem {...styles.orderSummeryTitleGridItem}>
                    <Typography as="h2" {...styles.orderSummeryTitle}>
                        {translate(title || "Order Summary")}
                    </Typography>
                </GridItem>
            </GridContainer>
            <Zone contentId={id} zoneName="Content_OrderSummaryWrapper" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderSummaryWrapper,
    definition: {
        displayName: "Order Summary Wrapper",
        group: "MyAccount" as any,
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "Order Summary",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
